import React, {useState, useEffect} from "react";
import {useNavigate } from "react-router-dom";
import  StartKYC  from "../StartKYC/StartKYC";
import classes from './FormBuyTokens.module.scss'
import { useTranslation } from "react-i18next";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const FormBuyTokens = (props :any) => {

    const [token, setToken] = useState('3')
    const [inDollars, setInDollars] = useState('')
    const [isDisabled, setDisabled] = useState(true)
    const navigate = useNavigate()
    const {t} = useTranslation()

    useEffect(() => {
        const tkn = +token
        const res = String(tkn * 50)
        setInDollars(res)
    },[token])

    useEffect(() => {
        if(props.status === 'APPROVED') {
            setDisabled(false)
        }
        else{
            setDisabled(true)
        }
    },[props.status])

    const handleButton = async () => { // проверка актуальности токена
        if(localStorage.getItem('token')) {
            // if(props.navigate){
            //     navigate('/cpayToken')
            // }
            // else{
            //     navigate('/')
            // }


            // try{
            //     const request = await axios.post(`https://secure.snd.payu.com/pl/standard/user/oauth/authorize`, 
            //     {
            //         data : 'grant_type=client_credentials&client_id=452870&client_secret=3e53b6153e0e94d47b44997ab5e19911'
            //     },
            //     {
            //         headers: {
            //             "Content-Type": "application/json", 
            //             "Access-Control-Allow-Origin" : "*", 
            //             "Access-Control-Allow-Headers" : "Origin, X-Requested-With, Content-Type, Accept"
            //         }
            //     }
            //     )
            //     console.log(await request)
            // }
            // catch(e){
            //     console.log(e)
            // }


            if(props.status === 'APPROVED'){
                console.log('approve')
                try{
                    const request = await axios.post(`api/v2_1/orders`, 
                    {
                        "notifyUrl": "https://your.eshop.com/notify",
                        "customerIp": "127.0.0.1",
                        "merchantPosId": "452870",
                        "description": "Artem",
                        "currencyCode": "PLN",
                        "totalAmount": "21",
                        "buyer": {
                            "email": "acprohor@gmail.com",
                            "phone": "654111654",
                            "firstName": "John",
                            "lastName": "Doe",
                            "language": "pl"
                        },
                        "products": [
                            {
                                "name": "Artem",
                                "unitPrice": "15000",
                                "quantity": "1"
                            }
                        ]
                    },
                    {
                        headers: {
                            "Authorization": "Bearer 78860ba0-66fc-4c68-af82-9d684aab48ba",
                            "Content-Type": "application/json", 
                            "Access-Control-Allow-Origin" : "*", 
                            "Access-Control-Allow-Headers" : "Origin, X-Requested-With, Content-Type, Accept"
                        }
                    }
                    )
                    console.log(await request)
                }
                catch(e){
                    console.log(e)
                }
            }
            else if(props.status === 'FAILED'){
                console.log('failed')
                toast.error('Pass identity authentication again')
            }
            else if(props.status === 'PENDING' || props.status === 'SUCCESSFUL'){
                console.log('success')
                toast.error('Please wait for a while')
            }
            else {
                console.log('empty')
                toast.error('Pass the identity authentication')
            }

        }
        else{
            navigate('/signUp')
        }
    }
    return(
        <div className={classes.buy}>
            <p className={classes.buy_title}>{t('buyPage')}</p>
            <div className={classes.buy__tokens}>
                <div className={classes.buy__tokens__token}>
                    <p className={classes.buy__tokens__token_title}>Tkn</p>
                    <input value={token} onChange={(e) => setToken(e.target.value)} className={classes.buy__tokens__token_input}/>
                </div>
                <div className={classes.buy__tokens__equal}>
                    <div className={classes.buy__tokens__equal_above}/>
                    <div className={classes.buy__tokens__equal_below}/>
                </div>
                <div className={classes.buy__tokens__dollars}>
                    <div className={classes.buy__tokens__dollars__left}>
                        <p className={classes.buy__tokens__dollars__left_item}>$</p>
                        <p className={classes.buy__tokens__dollars__left_value}>{inDollars}</p>
                    </div>
                    <div className={classes.buy__tokens__dollars__right}>
                        <div className={classes.buy__tokens__dollars__right_devider}/>
                        <p className={classes.buy__tokens__dollars__right_currency}>USD</p>
                    </div>
                </div>
                <button className={classes.buy__tokens_btn} disabled={isDisabled} onClick={handleButton}>{t('buyPage_button')}</button>
            </div>
            {/* <StartKYC /> */}
            {localStorage.getItem('token') && <StartKYC />}
            <ToastContainer 
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"/>
        </div>
    )
} 